/**
 * Symbol/Character for currency unit
 * @deprecated Due to Multiverse feature it's not recommended to use this hard coded stuff.
 *
 * */
export const CurrencySymbol = 'Ꞩ';

/**
 * The smallest possible fee
 * 
 */
export const FeeQuantPlanck = 1000000;

/**
 * One SIGNA expressed in Planck
 * 
 */
export const OneSignaPlanck = 100000000;
